import masterthesis from './../assets/images/masterthesis.png';
import ev from './../assets/images/externalvalidity.png';import knitrr from './../assets/images/knitrr.jpg';
import epinova from './../assets/images/epinova.jpeg';

const projectData = {
  masterthesis: {
    slug: 'masterthesis',
    demo: 'https://master-thesis-by-danny.vercel.app/',
    github: 'https://github.com/danny1401/master-thesis',
    title: "Master's Thesis",
    subtitle: 'Generalization claims in Software Engineering Research',
    date: '2026-01',
    genre: 'Data Analysis',
    description:
      'A website for showcasing my master thesis with interactive data visualizations of research data. ',
    overview: 'In the master thesis, I did an analysis of threats to external validity in controlled experiments with a focus on technologies and contextual factors.',
    features: [
      'Built a website using a scrollytelling technique to transform complex research findings into an intuitive visual narrative.',
      'Interactive charts to visualize research data such as key methodologies and experimental findings.',
    ],
    stack: ['React', 'TypeScript', 'Tailwind CSS', 'Python', 'Pandas', 'Matplotlib', 'Jupyter Notebook'],
    details: 'test',
    role_contribution: [
      'Analyzed how experimental technologies and processes in software development were put into practice.',
      'Performed exploratory data analysis (EDA) using Python and Jupyter Notebook with various libraries. Typical tasks included cleaning, analyzing, and visualizing research data.',
    ],
    challenges: [
      'Reading through dense, narrative-heavy research papers to identify key qualitative themes',
      'Defining clear taxonomy and boundaries to logically categorize unstructured data.',
    ],
    learnings: [
      'Gave me a practical understanding of software development research.',
      'Strengtened my technical understanding and ability to analyze data.'],
    thumbnail: masterthesis,
    image: ev,
  },
  bachelorthesis: {
    slug: 'bachelorthesis',
    demo: null,
    github: null,
    title: "Bachelor's Thesis",
    subtitle: 'Bachelor Name',
    date: '2023-06',
    genre: 'Full-Stack Development',
    category: [['Full-Stack Development']],
    description: '',
    overview: null,
    features: [],
    stack: [],
    details: null,
    role_contribution: [],
    challenges: [],
    learnings: [],
    thumbnail: epinova,
    image: epinova,
  },
  knitrr: {
    slug: 'knitrr',
    demo: null,
    github: null,
    title: 'Knitrr',
    subtitle: null,
    date: '2022-07',
    genre: 'Frontend Development',
    category: [['Frontend Development']],
    thumbnail: knitrr,
    image: knitrr,
    description: '',
  },
  ufo: {
    slug: null,
    demo: null,
    github: null,
    title: 'UFO Application',
    subtitle: null,
    date: '2022-11',
    genre: 'Full-Stack Development',
    category: [['Full-Stack Development']],
    image: null,
    description: '',
  },
  dhis: {
    title: 'DHIS',
    subtitle: null,
    slug: null,
    demo: null,
    date: '2023-12',
    genre: 'Full-Stack Development',
    category: [['Full-Stack Development']],
    image: null,
    description: '',
  },
  thoughts: {
    title: 'Thoughts App',
    subtitle: null,
    slug: null,
    demo: null,
    date: '2026-08',
    genre: 'Full-Stack Development',
    category: [['Computer Vision']],
    image: null,
    description: '',
  },
  portfolio: {
    slug: 'portfolio',
    demo: 'https://dannytran.no',
    github: null,
    title: 'Personal Portfolio',
    subtitle: 'A static web application showcasing my projects',
    date: '2026-08',
    genre: ['Web Development', 'Azure Deployment'],
    description: 'Developed a personal portfolio website to highlight my personal journey as a developer. It showcases my projects, technical skills, and professional experience in software development.',
    overview: null,
    features: [
      'Modern mobile-responsive UI with smooth navigation and modern design aesthetics.',
      'Dynamic project showcase with slug-based routing for detailed pages.',
      'Functional contact forms with seamless automated email delivery to personal email inbox.',
    ],
    stack: ['React', 'Javascript', 'Tailwind CSS', 'Azure Functions', 'Resend'],
    role_contribution: [
      'Frontend: Designed and built all UI components using React and Tailwind.',
      'Backend: Built serverless APIs using Azure Functions to seamlessly connect the backend application logic.',
      'Infrastructure: Hosted and managed on Microsoft Azure cloud infrastructure.',
      'Email Service: Integrated domain-level email services using Resend API for transactional email delivery and automated messaging.',
    ],
    challenges: [
      'Integration of Resend API into the domain to use as a personal email service for myself.',
      'Ensuring cross-browser and device compatibility for UI components.',
    ],
    learnings: [
      'Expanded my knowledge in domain administration and DNS routing architecture for reliable web hosting and email delivery.',
      'Gained experience in designing interactive UI components.',
    ],
    thumbnail: null,
    image: null,
  },
};

export default projectData;